export default __webpack_public_path__ + "static/media/s2.8d013e5b.png";